export const NavLinks = [
  { path: "/", label: "Home" },
  { path: "/about-me", label: "About Me" },
  { path: "/experience", label: "Experience" },
  { path: "/education", label: "Education" },
  { path: "/expertise", label: "Expertise" },
];
